import { DefaultTemplate } from "@components/templates/default";
import { HttpError, useParsed, useShow } from "@refinedev/core";
import { useAtomValue } from "jotai";
import { blogIdAtom } from "./state";
import { blogger_v3 } from "googleapis"
import { logger } from "@utils/logger";


export interface ContentShowProps {
    // postId: string
}

export function ContentShow({ }: ContentShowProps) {
    const blogId = useAtomValue(blogIdAtom)
    const { id } = useParsed();


    const { queryResult: { data, isLoading, isError } } = useShow<blogger_v3.Schema$Post, HttpError, blogger_v3.Schema$Post>({
        dataProviderName: 'gapi',
        resource: 'blogger/blogs/:blogId/posts/:postId',
        meta: {
            params: {
                blogId,
                postId: id
            }
        },
        queryOptions: {
            enabled: !!blogId
        }
    })

    const post = data?.data;
    logger.debug(post)

    return <DefaultTemplate>
        <div className="flex flex-col items-center px-2 target:bg-primary">
            {/* <h1>{post?.title}</h1> */}
            <div className="w-full lg:w-2/3 prose" dangerouslySetInnerHTML={{ __html: post?.content! }}></div>
        </div>
    </DefaultTemplate>
}
